module.exports = __webpack_public_path__ + "img/sorry.c53d15ba.gif";